/* G Decor — mobile PDP carousel pagination dots + body-class fallback.
 * - Adds .gd-vp-mobile to <body> when viewport <= 768px so CSS can target via
 *   class (some iframe previews don’t trigger media queries reliably).
 * - On the product template, builds a slim brass indicator under the main
 *   product carousel and tracks which slide is in view via IntersectionObserver.
 *
 * NOTE: <carousel-slider> is the HTML tag (custom element), not a class.
 * DOM queries use the tag name without the dot prefix.
 */
(function(){
  'use strict';

  var MQ = window.matchMedia('(max-width: 768px)');

  function syncBodyClass(){
    if (MQ.matches) document.body.classList.add('gd-vp-mobile');
    else document.body.classList.remove('gd-vp-mobile');
  }
  function init(){
    syncBodyClass();
    if (MQ.addEventListener) MQ.addEventListener('change', syncBodyClass);
    else if (MQ.addListener) MQ.addListener(syncBodyClass);
    window.addEventListener('resize', syncBodyClass);

    if (!document.body.classList.contains('template-product')) return;
    build();
    var resizeTimer;
    window.addEventListener('resize', function(){
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(build, 200);
    });
  }

  var dotsEl = null;
  var observer = null;
  var items = [];

  function build(){
    teardown();
    if (!MQ.matches) return;
    var gallery = document.querySelector('.media-gallery');
    if (!gallery) return;
    // Tag selector (no dot) — <carousel-slider> is a custom element, not a class.
    var carousels = gallery.querySelectorAll('carousel-slider');
    var main = null;
    for (var i = 0; i < carousels.length; i++) {
      if (!carousels[i].classList.contains('thumbnails')) { main = carousels[i]; break; }
    }
    if (!main) return;
    var grid = main.querySelector('.slider__grid');
    if (!grid) return;
    var slideEls = grid.querySelectorAll('.slider__item');
    if (slideEls.length < 2) return;
    items = Array.prototype.slice.call(slideEls);

    dotsEl = document.createElement('ul');
    dotsEl.className = 'gd-pdp-dots';
    dotsEl.setAttribute('aria-hidden', 'true');
    for (var j = 0; j < items.length; j++) {
      var dot = document.createElement('li');
      if (j === 0) dot.classList.add('is-active');
      dotsEl.appendChild(dot);
    }
    main.parentNode.insertBefore(dotsEl, main.nextSibling);

    observer = new IntersectionObserver(onIntersect, {
      root: grid,
      threshold: [0.55]
    });
    items.forEach(function(it){ observer.observe(it); });
  }

  function onIntersect(entries){
    if (!dotsEl) return;
    var dots = dotsEl.children;
    entries.forEach(function(entry){
      if (entry.intersectionRatio >= 0.55) {
        var idx = items.indexOf(entry.target);
        if (idx >= 0) {
          for (var k = 0; k < dots.length; k++) {
            if (k === idx) dots[k].classList.add('is-active');
            else dots[k].classList.remove('is-active');
          }
        }
      }
    });
  }

  function teardown(){
    if (observer) { observer.disconnect(); observer = null; }
    if (dotsEl && dotsEl.parentNode) dotsEl.parentNode.removeChild(dotsEl);
    dotsEl = null;
    items = [];
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
